<script>
</script>

<footer class="footer">
    <div class="logo-container">
        <h4>Printing Agent</h4>
    </div>
    <div class="socials-container">
        <a href="/"><i class="fab fa-facebook-square"></i></a>
        <a href="/"><i class="fab fa-instagram"></i></a>
      </div>
    <div class="copyright">
        <p>© Printing Agent 2022 | All rights protected</p>
    </div>
</footer>

<style>
    .footer{
        height: 20vh;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        justify-items: center;
        align-items: end;
        gap: 1rem;
        padding: 1rem;
        background-color: var(--headerColor);
    }
    h4{
        font-size: 1.5rem;
    }
    .socials-container i{
        font-size: 1.5rem;
        transition: all 300ms ease-in-out;
    }
    .socials-container i:hover{
        color: var(--mainWhite);
    }
    .fa-facebook-square {
        margin-right: 1rem;
    }
    .copyright{
        grid-column: 1/3;
    }
    .copyright p{
        font-size: 14px;
        font-weight: 500;
        text-align: center;
    }

    @media (max-width: 760px){
        h4 {
            font-size: 1.25rem;
        }
    }
    @media (max-width: 530px){
        .footer{
            height: auto;
        }
        h4 {
            font-size: 1.15rem;
        }
    }
</style>